/** Serverzustand der Checklistenvorlagen -- F1-19. */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { components } from '../../api/schema';
import { request } from '../../lib/apiClient';
import { ApiError } from '../../lib/apiError';

export type ChecklistTemplate = components['schemas']['ChecklistTemplateRead'];

const checklistTemplateKey = ['checklist-templates'] as const;

export function useChecklistTemplates() {
  return useQuery({
    queryKey: checklistTemplateKey,
    queryFn: () => request<ChecklistTemplate[]>('/checklist-templates'),
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.isPermanent) && failureCount < 2,
  });
}

function useInvalidate() {
  const queryClient = useQueryClient();
  return async () => {
    await queryClient.invalidateQueries({ queryKey: checklistTemplateKey });
  };
}

export function useCreateChecklistTemplate() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (payload: Record<string, unknown>) =>
      request<ChecklistTemplate>('/checklist-templates', { method: 'POST', body: payload }),
    onSuccess: invalidate,
  });
}

export function useDeleteChecklistTemplate() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (templateId: string) =>
      request<undefined>(`/checklist-templates/${templateId}`, { method: 'DELETE' }),
    onSuccess: invalidate,
  });
}
